import { computed, observable } from 'mobx';
import {ArtistSchema, TrackSchema} from '../../../types/schema';

export class FavouritesPageModel {
  @observable
  loading: boolean = true;

  @observable
  pageTitle: string = null;

  @observable
  pageBody: string = null;

  @observable
  noTracks: string = null;

  @observable
  noArtists: string = null;

  @observable
  noFavourites: string = null;

  @observable
  coverImage: string = null;

  @observable
  tracks: Array<TrackSchema> = [];

  @observable
  filteredTracks: Array<TrackSchema> = [];

  @observable
  tracksPage: number = 1;

  @observable
  tracksPerPage: number = 25;

  @observable
  tracksPagesTotal: number;

  @computed
  get infiniteTracks(): any {
    return {
      loading: false,
      loadingMore: false,
      tracks: this.filteredTracks
    }
  }

  @observable
  hasMoreTracks: boolean = true;

  @observable
  loadingMoreTracks: boolean = false;

  @observable
  artists: Array<ArtistSchema> = [];

  @observable
  filteredArtists: Array<ArtistSchema> = [];

  @observable
  artistsPage: number = 1;

  @observable
  artistsPerPage: number = 8;

  @observable
  artistsPagesTotal: number;

  @observable
  hasMoreArtists: boolean = true;

  @observable
  loadingMoreArtists: boolean = false;

  @computed
  get hasTracks(): boolean {
    return this.filteredTracks.length > 0;
  }

  @computed
  get hasArtists(): boolean {
    return this.filteredArtists.length > 0;
  }

  @computed
  get hasFavourites(): boolean {
    return this.hasArtists || this.hasTracks;
  }
}